import React, {useState} from "react";
import "./about.css";

import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";

import GovCertificate from "../../assets/images/certificates/gov_certificate.webp";
import IncomeCertificate from "../../assets/images/certificates/income_text_certificate.webp";
import Pancard from "../../assets/images/certificates/pan_card.png";
import ImgOne from "../../assets/images/certificates/popup_one.webp";
import ImgTwo from "../../assets/images/certificates/popup_two.webp";
import ImgThree from "../../assets/images/certificates/popup_three.webp";
import ImgFour from "../../assets/images/certificates/popup_four.webp";
import ImgFive from "../../assets/images/certificates/popup_five.webp";
import ImgSix from "../../assets/images/certificates/popup_six.webp";

const AboutUs = () =>{
    const [showPopup, setShowPopup] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    return(
        <>
         <Header />

         <div className="container-fluid">
          <div className="container">
            <div className="row">
                <div className="col-lg-12 pt_20 mt_30">
                <div className="heading_common mt_15">
                     <h3> About Us </h3>
                 </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row">
                <div className="col-lg-12 mt_15">
                 <div className="common_blocks mt_15">
                     <p>At <span class="common_color"> FMBGK,</span> we are passionate about providing house hold products that best quality with low cost. Founded in 2011, our journey began with a simple mission: to reach maximum Indian houses. Since then, we have become a thriving e-commerce platform destination, known for our commitment to quality, innovation, and customer satisfaction.</p>
                 </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row">
                <div className="col-lg-4 mt_15">
                 <div className="certificate_img mt_15">
                    <img src={GovCertificate} alt="" className="img-fluid rounded" />
                  </div>
                </div>
                <div className="col-lg-4 mt_15">
                 <div className="certificate_img mt_15">
                 <img src={IncomeCertificate} alt="" className="img-fluid rounded" />
                  </div>
                </div>
                <div className="col-lg-4 mt_15">
                 <div className="certificate_img mt_15">
                 <img src={Pancard} alt="" className="img-fluid rounded" />
                  </div>
                </div>
            </div>
        </div>
         <div className="container">
            <div className="row">
                <div className="col-md-12 ">
                    <div className="d_flex mt_30 gap_20 ">
                        {[ImgOne, ImgTwo, ImgThree, ImgFour, ImgFive, ImgSix].map((imgSrc, index) => (
                            <div className="certificate_img hover_img" key={index}>
                            <img
                                src={imgSrc}
                                alt=""
                                onClick={() => setSelectedImage(imgSrc)}
                                title="Click for Zoom"
                                className="img-fluid cursor_pointer"
                            />
                            </div>
                        ))}
                        </div>

                    {/* <div className="d_flex mt_30 gap_20 ">
                    <div className="certificate_img">
                        <img src={ImgOne} alt="" onClick={() => setShowPopup(true)} title="Click for Zoom" className="img-fluid hover_img cursor_pointer" />
                    </div>
                    <div className="certificate_img">
                        <img src={ImgTwo} alt="" onClick={() => setShowPopup(true)}  title="Click for Zoom" className="img-fluid hover_img cursor_pointer" />
                    </div>
                    <div className="certificate_img">
                        <img src={ImgThree} alt="" onClick={() => setShowPopup(true)}  title="Click for Zoom" className="img-fluid hover_img cursor_pointer" />
                    </div>
                    <div className="certificate_img">
                        <img src={ImgFour} alt="" onClick={() => setShowPopup(true)}  title="Click for Zoom" className="img-fluid  hover_img cursor_pointer" />
                    </div>
                    <div className="certificate_img">
                        <img src={ImgFive} alt="" onClick={() => setShowPopup(true)}  title="Click for Zoom" className="img-fluid hover_img cursor_pointer" />
                    </div>
                    <div className="certificate_img">
                        <img src={ImgSix} alt="" onClick={() => setShowPopup(true)}  title="Click for Zoom" className="img-fluid hover_img cursor_pointer" />
                    </div>
                </div> */}
                </div>
            </div>
         </div>
      </div>
       {selectedImage && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 d-flex align-items-center justify-content-center"
    style={{ zIndex: 1050 }}
    onClick={() => setSelectedImage(null)} // close on background click
  >
    <div
      className="position-relative"
      onClick={(e) => e.stopPropagation()} // prevent closing on image click
    >
      <img
        src={selectedImage}
        alt="Popup"
        className="img-fluid rounded shadow-lg"
        style={{ maxHeight: '90vh' }}
      />
      <button
        className="btn btn-light position-absolute top-0 end-0 m-2"
        onClick={() => setSelectedImage(null)}
      >
        ✕
      </button>
    </div>
  </div>
)}



        <Subscribe /> 
       <Footer />
      </>
    )
}

export default AboutUs;